(function () {
  const RD_STATION_ENDPOINT =
    'https://api.rd.services/platform/conversions?api_key=58182f039db26762a749dffc3b011baf';
  const CONVERSION_IDENTIFIER = 'newsletter_popup_hurley';
  const REQUEST_TIMEOUT_MS = 3000;

  function sendConversion(email) {
    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), REQUEST_TIMEOUT_MS);

    const payload = {
      event_type: 'CONVERSION',
      event_family: 'CDP',
      payload: {
        conversion_identifier: CONVERSION_IDENTIFIER,
        email: email,
        traffic_source: window.location.href // Envia a URL como origem para o RD aceitar e classificar o lead
      }
    };

    return fetch(RD_STATION_ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'accept': 'application/json'
      },
      body: JSON.stringify(payload),
      signal: controller.signal
    })
      .then((res) => {
        if (!res.ok) throw new Error(`HTTP error ${res.status}`);
        return res.json();
      })
      .then((data) => {
        console.log('Evento enviado com sucesso para o RD Station:', data);
      })
      .catch((err) => {
        console.error('Erro/Timeout no envio para o RD Station:', err);
      })
      .finally(() => {
        clearTimeout(timeoutId);
      });
  }

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.classList.contains('newsletter-form')) return;
    if (form.dataset.rdStationSent === 'true') return;

    const emailInput = form.querySelector('input[name="contact[email]"]');
    const email = emailInput ? emailInput.value.trim() : '';
    if (!email) return;

    event.preventDefault();
    const submitter = event.submitter;

    sendConversion(email).finally(() => {
      form.dataset.rdStationSent = 'true';
      submitter ? form.requestSubmit(submitter) : form.requestSubmit();
    });
  });
})();